export default "__VITE_ASSET__DjGkr2hq__"